document.addEventListener('DOMContentLoaded', function() {
  const wishlistContainer = document.querySelector('.wishlist-container');
  const wishlistLoadingContainer = document.querySelector('.wishlist-container-loading');
  const productContainer = document.querySelector('.product-grid, .product-slider');
  const description = document.querySelector('.description');
  const wishlistLabel = document.querySelector('.my-wishlist-text');
  
  const loadingSkeleton = `
    <div class="loading-placeholder"></div>
    <div class="loading-placeholder"></div>
    <div class="loading-placeholder"></div>
    <div class="loading-placeholder"></div>
    <div class="loading-placeholder"></div>
    <div class="loading-placeholder"></div>
`;

  // Fetch wishlist data from custom app endpoint
  const fetchWishlist = async () => {
    try {
      let emptyMessage = 'No items in this wishlist yet.';
      const url = new URL(window.location.href);
      const customerId = url.searchParams.get('customer_id');
      productContainer.innerHTML = loadingSkeleton;
      const response = await fetch(`https://wishlist.apps.aico.swiss/favourite-items?shop=${Shopify.shop}&customer_id=${customerId}&lang=${Shopify.locale}`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch wishlist');
      }
      
      const data = await response.json();
       productContainer.innerHTML = '';

      if(data.success && data.data.translations_data){
        const translations = JSON.parse(data.data.translations_data);
        
        const shareWishlistDescription = translations.wishlist_page.find(
          item => item.id === "share_wishlist_description"
        ).value;
        const myWishlistText = translations.wishlist_page.find(
          item => item.id === "link_to_my_wishlist"
        ).value;
        const myText = translations.wishlist_page.find(
          item => item.id === "my_wishlist"
        ).value;
        emptyMessage = translations.wishlist_page.find(
          item => item.id === "empty_shared_wishlist"
        ).value;
        description.innerText = shareWishlistDescription;
        wishlistLabel.innerText = myText + ' ' + myWishlistText;
        // console.log(myWishlistText,'text')
        
      }
      if (data.success && data.data.wishlist_data && data.data.wishlist_data.length > 0) {
        data.data.wishlist_data.forEach(item => {

          let productTitle = item.product_title; // Default to original title
          if (data.data.metafields_data && data.data.metafields_data[item.product_id]) {
            const metafields = data.data.metafields_data[item.product_id];
            // Select the title based on the current locale
            const localeMap = {
              'fr': 'title_fr',
              'en': 'title_en',
              'it': 'title_it',
              'de': 'title_de_ch' // Assuming 'de' for German (Swiss)
            };
            const titleKey = localeMap[Shopify.locale] || 'title_en'; // Fallback to English
            const metafield = metafields.find(meta => meta.key === titleKey);
            if (metafield && metafield.value) {
              productTitle = metafield.value; // Use translated title if available
            }
            console.log(productTitle,'title');
          }

          const hasComparePrice = item.product_compare_at_price && parseFloat(item.product_compare_at_price) > 0;
          const comparePriceStyle = hasComparePrice ? 'text-decoration: line-through; margin-right:10px' : '';
          const productDiv = document.createElement('div');
          productDiv.className = 'product';
          productDiv.innerHTML = `
            <a href="https://${Shopify.shop}${item.product_handle}" target="_blank">
                <img src="${item.product_image}" alt="${productTitle || 'Item Image'}">
                <div class="aico-wishlist-product-details">
                  <p class="p-title">${productTitle || 'wishlist item'}</p>
                  <p class="p-price">
                    ${hasComparePrice ? `<span style="${comparePriceStyle}">CHF ${parseFloat(item.product_compare_at_price).toFixed(2)}</span>` : ''}
                    <span>CHF ${parseFloat(item.product_price || 0).toFixed(2)}</span>
                  </p>
                </div>
            </a>
          `;
          productContainer.appendChild(productDiv);
        });
  
      } else {
        wishlistContainer.innerHTML += `<p class="no-items">${emptyMessage}</p>`;
      }
    } catch (error) {
      console.error('Error fetching wishlist:', error);
      wishlistContainer.innerHTML += '<p class="no-items">Error loading wishlist. Please try again later.</p>';
    }
  };
  
  // Call the async function
  fetchWishlist();
});